/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-11-03 09:53:59
 * @LastEditors: lijing
 * @LastEditTime: 2026-04-23 16:08:49
 */
import en from 'element-ui/lib/locale/lang/en'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: 'AI Report Analysis',
        train: 'Training Outline',
        loading: 'Loading, please wait...',
        loadingError1: 'The report failed to load',
        loadingError2: 'We apologize for the inconvenience. Please refresh and try again.',
    },
    // 登录页面
    login: {
        loginAndRegister: 'Sign up / Log in',
        registerAndLogin: 'Log in / Sign up',
        userLogin: 'Log In',
        title: 'Mobile and email accounts are independent; please note your account type.',
        mobileLogin: 'Phone',
        emailLogin: 'Email',
        email: 'E-mail',
        loginBtn: 'Log In',
        autoLogin: 'Remember me',
        retransmission: '{item}s',
        formList: [
            {
                label: 'Enter your phone number',
                placeholder: 'Send',
            },
            {
                label: 'Verification Code',
                placeholder: 'Enter verification code',
            },
            {
                label: 'Please enter your email',
            },
        ],
        btn: {
            submit: 'Create Account',
            title: "In order to have the accurate data, it's important to put in the right height, gender and age.",
        },
        rule: {
            phone: {
                requiredMsg: 'Invalid Phone Number Format',
                patternMsg: 'Phone Not Registered , Creat Your Account',
            },
            authCode: {
                requiredMsg: 'Wrong Verification Code, Please Re-Type',
            },
            email: {
                requiredMsg: 'Wrong Email Format ',
                patternMsg: 'Email Not Registered, Create Your Account',
            },
        },
        codeSuccess: 'The verification code has been sent, please check.',
        success: 'Sending Successed',
        error: 'Sending failure',
        loginSuccess: 'Login Successed',
        account: {
            accountTitle: 'Log In',
            registerTitle: 'Sign In',
            resetTitle: 'Set Password',
            password: 'Password',
            placeholder: 'Please enter your password',
            codeLogin: 'Login with verification code',
            accountLogin: 'Login with password',
            forgotPassword: 'Forgot password?',
            registerTips: [
                'Don’t have an account?', 
                'Sign In', 
                'Account already exists',
                'Sign Up',
            ],
            checkRule: [
                '8-20 characters',
                'Must include at least one uppercase letter',
                'Must include at least one lowercase letter',
                'Must include at least one number',
                'Passwords do not match',
            ],
            errorTips: ['Incorrect password', 'Login failed', 'Account does not exist'],
            reset: [
                'Reset Password',
                'Next',
                'New password cannot be the same as the previous password',
                'Skip',
                'Password set successfully',
            ],
            setPasswordTips:
                'The password must be 8-20 characters long and include uppercase letters, lowercase letters, and numbers.',
            confirmPassword: 'Confirm password',
        },
        switchButton: 'Password Login',
        switchButton1: 'Login with verification code',
        loginTips: 'Unregistered accounts will be automatically registered upon successful login.',
        otherLogin: 'Other Login Methods',
        newEmailLogin: 'Email login',
        newPhoneLogin: 'Mobile number login',
        bindLineTips:'Or',
        bindEmail: 'Bound Email Login',
        bindPhone: 'Bound Phone Number Login',
        bindAndContinue: "Bind and continue",
        bind: "Bind",
        bindEmailTitle: 'Bind Email',
        bindEmailTips1: "Unable to retrieve your {item} Email info",
        bindEmailTips2: "Bind email to continue",
        bindEmailTips3: "Your account is not yet bound to an Email address. After binding, you can log in via Email and reset your password.",
        boundTitle: 'Registered before?',
        boundCenterTitle1:'If you are a new user',
        boundCenterTips1:'Create an account to start',
        boundCenterTitle2:'If you already have an account',
        boundCenterTips2:'Bind to sync historical data',
        boundCenterTips3:'Please link a registered account',
        boundCenterTips4:'Recommended',
        boundCenterTips5:'Bind {item} to existing account',
        boundCenterTips6:'Data and reports will sync automatically',
        boundButton1: 'Create account with {item}',
        boundButton2: 'Bind existing account',
        phoneCode:"SMS Code Login",
        phonePassword:"Phone Password Login",
        emailCode:"Email Code Login",
        emailPassword:"Email Password Login",
        accountDoesNotExist:"This account is not registered. Please sign up using an email verification code or via {item}.",
        toRegister:"Sign Up",
        bindNow: "Link Now",
        bindError:[
            'Binding Failed',
            'Unbinding Successful',
            'Unlink Failed',
            'Authorization Failed',
            'Authorization Failed, Unable to Retrieve Account Information',
            'Link Successful',
            'Account does not exist. Please link a registered account.',
            'Linking failed. This account is already linked with the {item} account [{nickname}].',
            'Authorized and registered as an account, unlinking is not supported',
            'Account does not exist, please use the verification code to log in and register',
        ],
        accountSecurity: {
            faceBook:'Facebook Account',
            google: 'Google Account',
            isBind: 'Not Bound',
            dialogTitle: 'Confirm Unbinding?',
            dialogCenter: 'After unbinding {item}, you will no longer be able to use it to log in to this account.',
            bindFailure:'Binding Failed',
            bindFailureTips: 'Your {item} account is already bound to the account below. If you want to switch the binding to the current account, please log in to the account below to unbind it first.',
            returnButton:'Confirm and Return'
        },
        bindEmailError: [
            "Email exists. Use another."
        ],
    },
    // 注册页面
    register: {
        mobileRegister: 'Phone',
        emailRegister: 'Email',
        enroll: 'Cellphone Number Already Registered',
        enrollEmail: 'Email is registered',
        search: 'Search',
        title: 'Mobile and email accounts are independent; please note your account type.',
        needRead: {
            agree: 'I agree',
            privacy: '(Privacy Policy)',
        },
        register: 'Sign In',
        check: "Check ' User Privacy '",
        newUser: 'Sign In',
        form: {
            labelList: ['Name', '* Gender', '* Height', '* Age'],
        },
        placeholder: ['Please enter your name', 'Please enter your height', 'Please enter your age'],
        unit: ['Metric', 'Imperial', ''],
        sexOptions: {
            male: 'Male',
            female: 'Female',
        },
        btn: 'Submit',
        rules: {
            metricheight: ["The height range is 2'3'' - 6'7'', please enter it again."],
            heightMsg: ['The height range is 70 - 200cm, please enter it again.'],
            ageMsg: ['The age range is 10 - 99, please enter it again.'],
            agePointMsg: ['Filled in non-integer: age can only be an integer, please fill in the correct age'],
        },

        success: 'Registration successed',
        userMessage: 'Enter User Name',
        verify: 'Enter 4 Digital Verification Code',
        errorMsg: 'height format does not support decimals, please re-enter',
        abnormalMsg: 'Registration anomaly',
    },
    // 模型合成
    model: {
        loading: 'Loading...Please wait a moment',
        modelLoading: '3D Model Loading',
        tabPane: [
            {
                title: 'Deep Real Sense Technology',
                msg: 'Accurately collect local details of the body through 3D scanning, ensure the millimeter-level accuracy of girth measurement, and clearly present the body shape changes after work-out.',
            },
            {
                title: 'BDA Body Composition Algorithm',
                msg: 'Visbody uses the most advanced body composition measurement system - BDA algorithm to determine body composition. This calculation method based on body volume will more accurately assess the health risks brought by obesity.',
            },
            {
                title: 'Factors that caused errors',
                msg: 'Loose clothing or some decorations on/in the body will cause errors, please wear tights or reduce the amount of clothing on your body if you want to get the most accurate data.',
            },
            {
                title: 'Get your report',
                msg: 'It is recommended to bookmark the web page URL for easy viewing of the report in the future. You can also send this report to your mailbox to save it later.',
            },
        ],
        collect: ['Please bookmark this page, Easy to review the report in the future.', ''],
        know: 'I Got It',
        reminder: [
            'Kindly Remind',
            'Your 3D avatar model has been generated, swiping to left and right to rotate the model.',
            "Your report has been generated and can be viewed by clicking the 'View Report' button.",
            'Your body assessment is unsuccessful, please review the body composition report.',
            'Your body composition was unsuccessful, please review the postural assessment report.',
            'Your measurement is unsuccessful, please go to the device and test again.',
            'The body composition measurement is unsuccessful, please go to the device and test again.',
            'The posture assessment is unsuccessful, please go to the device and test again.',
        ],
        btn: {
            viewReport: 'View Report',
            bodyReport: 'View Body Composition Report',
            postureReport: 'View Body Posture Report',
            lastReport: 'View Last Report',
            loading: 'Loading',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Download The Report',
            send: 'Send Report',
            report: 'Report',
        },
        reportSuccess: 'Successd!',
        tabPane: {
            labelList: ['Measure Time', 'Item', 'Body Composition', 'Posture Assessment', 'Shoulder Function'],
        },
        sendEmail: 'Email:',
        requiredMsg: 'Enter your email address',
        patternMsg: 'Please enter a vaild email address',
        send: 'Send',
        download: 'Download The Report',
        sendReport: 'Send Report',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Gender changed successfully',
            height: 'Height changed successfully',
            age: 'Age changed successfully',
        },
        logOut: 'Log Out',
        personal: 'Personal Center',
        cut: 'Change Units/Languages',
        changeSort: 'Product Report Switching',
        setPassword: 'Set/Change Password',
        accountSecurity: 'Account and Security',
        describe:
            '* After switching the product model, all measurement reports under this model will be displayed.',
        describeBtn:
            'After switching the product model, you will be redirected to the latest measurement report under this model.',
        descReport: 'Product Report Switch Successed',
        unit: ['Metric (kg, cm)', 'Imperial (ft, in, lb)'],
        read: {
            reading: 'Read ',
            privacy: '(Privacy Policy)',
        },
        setting: 'Setting',
        form: {
            labelList: ['Phone', 'Units', 'Languages', 'Name', 'Gender', 'Height', 'Age'],
        },
        placeholder: ['Change Your Username', 'New Gender', 'Height Updated', 'Age Updated'],
        btn: {
            cancelBtn: 'Cancel',
            accomplishBtn: 'Complete',
            confirmBtn: 'Confirm',
        },
        dialog: [
            'Gender is one of the important bases for body composition measurement. The data measured after modification will be different from the previous data. Please confirm if you want to change it?',
            'Height is one of the important bases for body composition measurement. The data measured after modification will be different from the previous data. Please confirm if you want to change it?',
            'Age is one of the important bases for body composition measurement. The data measured after modification will be different from the previous data. Please confirm if you want to change it?',
        ],
        rules: {
            metricheight: ["Please fill in the correct height range (2' 3'' to 6'7'')"],
            heightMsg: ['Please fill in the height within 70cm - 200cm'],
            ageMsg: [
                'Please fill in the age within 10 - 99 years old.',
                'Filled in non-integer ,age can only be an integer, please fill in the correct age',
            ],
        },
        heightMsg: 'Please Re-Choose Height',
        ageMsg: 'Please Re-Choose Age',
        ModelBinding: 'It seems that someone has scanned the code already, please measure again!',
        ReportEmpty: {
            title: "You don't have any report yet",
            desc: 'Come to Visbody 3D body scanner and test again!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'It seems that someone has scanned the code already, please measure again!',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: "You don't have any report yet",
        desc: 'Come to Visbody 3D body scanner and test again!',
        descS30: 'Come to Visbody-S30 3D body scanner and test again!',
        descM30: 'Come to Visbody-M30 3D body scanner and test again!',
    },
    // 用户信息
    userInfo: {
        height: 'Height:',
        age: 'Age:',
        unit: '',
        weight: 'weight',
    },
    // 结论
    assessment: {
        great: ' great',
        good: ' good',
        normall: 'normal',
        weak: ' weak',
    },
    // 体成分
    mass: {
        title: 'Body Composition Assessment Overview',
        titles: 'Body Composition',
        springFrame: '',
        massFrame: 'No measurement data for the day',
        contrast: 'Choose a report to compare',
        contrastReport: 'Choose a report to compare',
        noRecord: 'No records',
        score: 'Score',
        status: 'Your current body composition status ',
        WT: 'weight',
        PBF: 'body fat percentage',
        endSymbol: '.',
        measure: {
            value: 'Values',
            standardRange: 'Standard range',
            comparedWithLastLime: 'Net',
            comparedNet: 'Compared To The Last Score',
            current: 'Current Measurement Score',
            WT: 'Weight',
            FFM: 'Lean Body Mass',
            BFM: 'Body Fat Mass',
            LM: 'Muscle Mass',
            TBW: 'Body Water',
            SM: 'SMM (Skeletal Muscle Mass)',
            PROTEIN: 'Protein',
            TM: 'Inorganic Salts',
            BMR: 'Basal Metabolism Rate',
            WHR: 'WHR (Waist-Hip Ratio)',
            BMI: 'BMI',
            PBF: 'BFP (Body Fat Percentage)',
            VFG: 'Visceral Fat Level',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },
        explain: [
            {
                title: 'Weight',
                msg: 'Weight is the sum of body water, protein, inorganic salts and body fat.',
            },
            {
                title: 'Lean Body Mass',
                msg: 'Lean Body Mass is the total body weight without fat.',
            },
            {
                title: 'Body Fat Mass',
                msg: 'Body Fat mass is the sum of subcutaneous fat, visceral fat and muscle fat.',
            },
            {
                title: 'Muscle Mass',
                msg: 'Soft lean mass is the lean body mass, which includes skeletal muscle, smooth muscle, and cardiac muscle.',
            },
            {
                title: 'Body Water',
                msg: 'Most of the human body is water with an amount of 50%-70% of body weight. And body water is mainly in human cells and body fluids, most of which is in muscle cells.',
            },
            {
                title: 'SMM',
                msg: 'Skeletal muscle mass, also known as striated muscle, is a type of muscle attached to bones. This data contains the amount of Skeletal Muscle.',
            },
            {
                title: 'Protein',
                msg: 'Protein is a solid substance with ammonia, which exists in all cells of the human body. It is the main component of muscle mass.',
            },
            {
                title: 'Inorganic Salts',
                msg: 'The human body is composed of organic matter, inorganic matter and water. The inorganic matter here is inorganic salts which amounts to 5% of the body weight.',
            },
            {
                title: 'Basal Metabolism Rate',
                msg: 'Basal Metabolism rate is the total energy consumed in a day when the body is at rest, not affected by exercise, physical objects, nervousness, external temperature changes, etc.',
            },
            {
                title: 'WHR (Waist-Hip Ratio)',
                msg: 'The ratio of waist to hip circumference, it is an important indicator for determining central obesity.',
            },
            {
                title: 'BMI',
                msg: 'BMI is mainly used to assess the appearance of obesity, and it is a common standard for measuring body fatness.',
            },
            {
                title: 'BFP (Body Fat Percentage)',
                msg: 'BFP is a measurement of body composition telling how much of the body weight is fat.',
            },
            {
                title: 'Visceral Fat Level',
                msg: 'Visceral fat is an important indicator to evaluate the hidden obesity.',
            },
            {
                title: 'ICW',
                msg: 'ICW: It is  the body fluid contained in the body cells and is the basic component of the  protoplasm.',
            },
            {
                title: 'ECW',
                msg: 'ECW: Usually  refers to extracellular body fluids, including plasma and interstitial fluid  between blood vessels and tissue cells.',
            },
            {
                title: 'Metabolic Age',
                msg: 'Metabolic age refers to the performance of the body and its metabolism-related health functions.',
            },
            {
                title: 'ECW/TBW Ratio',
                msg: "The ECW/TBW Ratio is the proportion of Extracellular Water (ECW) in Total Body Water (TBW). It is an important indicator for assessing the body's fluid balance.",
            },
        ],
        segment: {
            fat: 'Segmental Fat Analysis',
            muscle: 'Segmental Lean Analysis',
            right: 'Right',
            left: 'Left',
            standard: 'Normal',
            lowStandard: 'Under',
            superStandard: 'Over',
            peel: '(Tare)',
        },
    },
    // 体态
    shape: {
        title: 'Body Assessment Overview',
        titles: 'Posture Assessment',
        status: 'Your current physical condition ',
        suggest: 'Suggestion',
        possibility: ', there is a possibility of ',
        models: {
            front: 'Front',
            left: 'Left Side',
            right: 'Right Side',
            top: 'Back',
            low: ' Under',
            high: ' Over',
            normal: 'Normal',
        },
        item: {
            deviate: 'Values',
            result: ' Explaination',
            normal: 'Normal',
            keAbnormal: 'Suspected Abnormality',
            abnormal: 'Abnormal',
            head: 'forward head posture',
            headSlant: 'head tilt',
            roundShoulderLeft: 'rounded shoulders posture(left side)',
            roundShoulderRight: 'rounded shoulders posture(right side)',
            highLowShoudler: 'uneven shoulders',
            pelvis: 'Pelvic forward/Pelvic posterior displacement',
            leftKneeCheck: 'left knee evaluation ',
            rightKneeCheck: 'right knee evaluation',
            leg: 'leg shape',
            leftLeg: 'Left leg:',
            rightLeg: 'Right leg:',
        },
        explain: [
            {
                title: 'Forward Head Posture',
                msg: 'The angle between the ear point on the left side and the line connecting the center of the neck and the median line on the side',
            },
            {
                title: 'Head Tilt',
                msg: 'The angle between the midpoint of the front head and the center of the neck and the midline of the front',
            },
            {
                title: 'Rounded Shoulders Posture(left side)',
                msg: 'The angle between the line connecting the highest point on the left side of the back and the tangent line of the shoulder',
            },
            {
                title: 'Rounded Shoulders Posture(right side)',
                msg: 'The angle between the line connecting the highest point on the right side of the back and the tangent to the shoulder',
            },
            {
                title: 'Uneven Shoulders',
                msg: 'The vertical distance between the left and right shoulder points on the back',
            },
            {
                title: 'Pelvic forward/Pelvic posterior displacement',
                msg: 'The included angle of the line connecting the center point of the neck, the hip bone point, and the ankle point on the left side',
            },
            {
                title: 'Left Knee Evaluation',
                msg: 'The included angle of the three-point line connecting the hip bone point, knee joint, and ankle point on the left side',
            },
            {
                title: 'Right Knee Evaluation',
                msg: 'The included angle of the three-point line connecting the hip bone point, knee joint, and ankle point on the right side',
            },
            {
                title: 'Leg Shape',
                msg: 'The included angle of the line connecting the hip bone point, knee joint, and ankle point on the front of the left and right legs',
            },
            {
                title: 'Pelvic Anterior/Posterior Tilt',
                msg: 'The angle between the vertical and the plane formed by the left and right Anterior Superior Iliac Spines and the Pubic Symphysis.'
            },
            {
                title: 'Leg Length Discrepancy',
                msg: 'The height difference between the lowest points of the left and right gluteal folds from the ground.'
            }
        ],
        exception: [
            {
                title: 'Inclined to Left Side',
                abnormal: 'inclined to left side',
            },
            {
                title: 'Inclined to Right Side',
                abnormal: 'inclined to right side',
            },
            {
                title: 'Left High',
                abnormal: 'left high',
            },
            {
                title: 'Right High',
                abnormal: 'right high',
            },
            {
                title: 'Posterior Pelvic Tilt',
                abnormal: 'posterior pelvic tilt',
            },
            {
                title: 'Anterior Pelvic Tilt',
                abnormal: 'anterior pelvic tilt ',
            },
            {
                title: 'Hyperextension of the Left Knee',
                abnormal: 'hyperextension of the left knee',
            },
            {
                title: 'Left Knee Forward Bending',
                abnormal: 'left knee forward bending',
            },
            {
                title: 'Hyperextension of The Right Knee',
                abnormal: 'hyperextension of the right knee',
            },
            {
                title: 'Right Knee Forward Bending',
                abnormal: 'right knee forward bending',
            },
            {
                title: 'K-shaped Legs',
                abnormal: 'k-shaped legs',
            },
            {
                title: 'D-shaped Legs',
                abnormal: 'd-shaped legs',
            },
            {
                title: 'X-shaped Legs',
                abnormal: 'x-shaped legs',
            },
            {
                title: 'O-shaped Legs',
                abnormal: 'o-shaped legs',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: "Vertical distance between the ears and the body's gravity line",
            },
            {
                msg: 'Angle between the line connecting both ears and the horizontal plane',
            },
            {
                msg: 'Vertical distance between the left acromion process and the gravity line',
            },
            {
                msg: 'Vertical distance between the right acromion process and the gravity line',
            },
            {
                msg: 'Difference in the lines connecting the base of the neck and acromion processes on both sides',
            },
            {
                msg: "Vertical distance between the hip joint and the body's gravity line",
            },
            {
                msg: 'Angle formed by the ankle joint, a point 1 cm inferior to the left knee joint, and the hip joint in the sagittal plane',
            },
            {
                msg: 'Angle formed by the ankle joint, a point 1 cm inferior to the right knee joint, and the hip joint in the sagittal plane',
            },
            {
                msg: 'Angle between bilateral hip joints, knee joints, and ankle joints in the coronal plane',
            },
        ],
        item: {
            pelvis: 'Anterior pelvic tilt',
        },
    },
    // 体围
    girth: {
        title: 'Circumferences',
        present: '(Present)',
        noHistory: 'No data.',
        tpl: [
            {
                title: 'Neck circumference',
                key: 'neckGirth',
            },
            {
                title: 'Left upper arm',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Right upper arm',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Chest',
                key: 'bustGirth',
            },
            {
                title: 'High waist',
                key: 'waistGirth',
            },
            {
                title: 'Mid waist',
                key: 'midWaistGirth',
            },
            {
                title: 'Hips',
                key: 'hipGirth',
            },
            {
                title: 'Left thigh',
                key: 'leftThighGirth',
            },
            {
                title: 'Left thigh middle',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Minimum circumference of left thigh',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Right thigh',
                key: 'rightThighGirth',
            },
            {
                title: 'Right thigh middle',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Minimum circumference of right thigh',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Left calf circumference',
                key: 'leftCalfGirth',
            },
            {
                title: 'Right calf circumference',
                key: 'rightCalfGirth',
            },
            {
                title: 'Low waist',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Shoulder Function',
        model: {
            val: 'Values',
            scope: 'Maximum Activity Location',
            diff: 'Net',
        },
        normal: 'Notable abnormalities not detected',
        normalAll: 'No significant abnormalities in shoulder function have been detected',
        conclusion: 'Conclusion',
        analyse: 'Analysis:',
        suggest: 'Suggestion:',
        cause: 'Please ask advices from experts for the details.',
    },
    reportTips: {
        title: "Are you sure you want to delete this report? Once deleted, it cannot be recovered.",
        confirm: "Delete",
        success: "Report has been deleted",
        partial: "Report has been deleted, and some data synchronization failed. Please contact the administrator.",
        failed: "Deletion failed. Please try again later.",
        btnMsg: 'OK',
        alaryTips: 'This report has been deleted by the administrator. Will jump to the next report!',
    },
    saveQr: {
        title: 'Visbody 3D Body Scanner Report',
        btnMsg: 'Long press the image to save it to your phone.',
        tips: 'If you find that you cannot save, please go to [Settings] and open the corresponding permissions.',
    },
    share: {
        title: 'Please copy the link below and share it.',
        btnMsg: 'Copy',
    },
    bodyPrediction: {
        'body-title': 'Body Shape Prediction',
        'body-yu-ce-status': 'Prediction based on your current status.',
        'body-setting': 'Body Shape Prediction Settings',
        'body-li-xiang': 'Ideal values: ',
        'body-ti-zhong': 'Weight',
        'body-ti-zhi-lv': 'Body Fat %',
        'body-ji-rou': 'Muscle Mass',
        'yu-che-pre': 'Before',
        'yu-che-after': 'After',
        'zan-model-no': 'No model available.',
        'ti-xing-error': 'Body shape prediction failed.',
        'ti-xing-worker-error': 'This may be due to network issues. Please check your connection.',
        'ti-xing-adjust': 'Adjustment:',
        'ji-rou-title': 'Muscle Mass',
        'ti-zi-fang': 'Body Fat',
        'dang-pre-zhi': 'Current Values: ',
        'nen-zhang': 'Visceral Fat Level',
        'nen-zhang-title': 'Visceral Fat Area Description',
        'nen-zhang-title1':
            'Visceral fat: Fat surrounding internal organs, causing abdominal obesity. Area indicates cross-sectional measurement.',
    },
    "waist": {
    "title": "Waist and Abdominal Assessment",
    "hou": "Back",
    "qian": "Front"
  },
  "yao_wei_1": "Waist",
  "yao_bu_fen_shu": "Waist Score",
  "waist_fen": "Score",
  "yao_wei": "Waist Circumference",
  "yao_wei_jian_ti_ji": "Volume Between Waistlines",
  "yao_tun_bi": "WHR",
  "lun_kuo_fen_xi": "Contour Analysis",
  "bei_bu": "Back Region",
  "tunbu": "Gluteal Region",
  "bei_bu_ti_ji": "Back Volume",
  "zheng_chang_fan_wei": "Normal Range:",
  "shang_ci": "Prev. ",
  "ben_ci": "Curr. ",
  "gupen": {
    "zheng_chang": "Normal",
    "qian_qin_yan_chang": "Abnormal Anterior Tilt",
    "qian_qin_yi": "Anterior Tilt Risk",
    "hou_qin_yi": "Posterior Tilt Risk",
    "hou_qin_yan_chang": "Abnormal Posterior Tilt",
    "zuo_chang_yan_chang": "Abnormal Left Leg Length",
    "zuo_chang_yi": "Left Leg Length Risk",
    "you_chang_yi": "Right Leg Length Risk",
    "you_chang_yan_chang": "Abnormal Right Leg Length"
  },
  "gao_yao_xian": "High Waist",
  "gao_yao_zhong_xian": "High Waist Midline",
  "gao_yao_xia_xian": "High Waist Lower Line",
  "xiao_yao_shang_xian": "Low Waist Upper Line",
  "xiao_yao_zhong_xian": "Low Waist Midline",
  "xiao_yao_xian": "Low waist",
  "qv_jian1": "High Waist Upper Section",
  "qv_jian2": "High Waist Lower Section",
  "qv_jian_zhong": "Mid-Waist Section",
  "qv_jian3": "Low Waist Upper Section",
  "qv_jian4": "Low Waist Lower Section",
  "celiang.failed": "Measurement unsuccessful. Please wear form-fitting clothing and remain stationary during measurement",
    ...en,
    ...agrEn,
    wifi: {
        'title': 'Wi-Fi Settings',
        'tips': 'Please enter the password for the following WiFi network',
        'password':'WiFi Password',
        'password-placeholder': 'Please enter WiFi password',
        'password-tips': 'The password is case-sensitive, please ensure you enter it correctly',
        'button': 'Generate QR Code',
        'h5-title': 'Configure WiFi Information',
        'wifi-name': 'WiFi name:',
        'wifi-password': 'WiFi password:',
        'wifi-qr-tips1': 'Please confirm your Wi-Fi details. Then, hold the QR code up to the camera located below the screen to scan. ',
        'wifi-qr-tips2': 'Align the Wi-Fi QR code with the camera below the screen to scan',
        'wifi-qr-button': 'Back',
    },
    "jie-gou-yi-chang-ping-gu": "Structural Abnormality Assessment",
  "teng-tong-feng-xian-ping-gu": "Pain Risk Assessment",
  "zheng-chang": "Normal",
  "qing-du-yi-chang": "Mild Abnormality",
  "zhong-du2-yi-chang": "Moderate Abnormality",
  "zhong-du-yi-chang": "Severe Abnormality",
  "pen-gu-zhuan-xiang-feng-xian-ping-gu": "Pelvic Health Risk Assessment",
  "qian-qing": "Anterior Tilt",
  "hou-qing": "Posterior Tilt",
  "xuan-zhuan": "Rotation",
  "pen-gu-qian-qing-feng-xian-fen-shu": "Anterior Pelvic Tilt Risk Score",
  "pen-gu-hou-qing-feng-xian-fen-shu": "Posterior Pelvic Tilt Risk Score",
  "pen-gu-xuan-zhuan-feng-xian-fen-shu": "Pelvic Rotation Risk Score",
  "fen": "Score",
  "gao-feng-xian": "High Risk",
  "ji-rou-ping-gu-jie-guo": "Muscle Assessment Results",
  "qian-qing-feng-xian-gao": "High Risk of Anterior Tilt",
  "hou-qing-feng-xian-gao": "High Risk of Posterior Tilt",
  "xuan-zhuan-feng-xian-gao": "High Risk of Rotation",
  "qia-yao-ji-shu-ji-ji-xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "Tight iliopsoas/lower erector spinae, weak transversus abdominis.",
  "gu-hou-ji-qun-tun-ji-shu-ji-ji-jin-zhang-qia-yao-ji-ruo": "Tight hamstrings, glutes, and erector spinae; weak iliopsoas.",
  "dan-ce-tun-zhong-ji-bao-ruo-yao-fang-ji-bu-ping-heng": "Unilateral weakness of gluteus medius / imbalanced quadratus lumborum.",
  "gu-pen-xiang-guan-ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Pelvic muscle assessment is normal. Please continue to maintain your healthy lifestyle.",
  "yi-shang-xiang-mu-jun-zheng-chang": "All items above are normal.",
  "ji-zhu-jie-gou-yi-chang-ping-gu": "Spinal Structural Abnormality Assessment",
  "zheng-ti-ping-fen": "Overall Score",
  "jing-zhui": "Cervical Spine",
  "xiong-zhui": "Thoracic Spine",
  "yao-zhui": "Lumbar Spine",
  "jing-zhui-jie-gou-yi-chang-ping-fen": "Cervical Spine Abnormality Score",
  "xiong-zhui-jie-gou-yi-chang-ping-fen": "Thoracic Spine Abnormality Score",
  "yao-zhui-jie-gou-yi-chang-ping-fen": "Lumbar Spine Abnormality Score",
  "jing-zhui-ji-rou-ping-gu": "Cervical Spine Muscle Assessment",
  "xiong-zhui-ji-rou-ping-gu": "Thoracic Spine Muscle Assessment",
  "yao-zhui-ji-rou-ping-gu": "Lumbar Spine Muscle Assessment",
  "ji-zhu-zheng-ti-pai-lie-ji-ben-zheng-chang": "Overall spinal alignment is generally normal.",
  "tou-bu-zi-tai-he-jing-zhui-pai-lie-ji-ben-zheng-chang": "Head posture and cervical alignment are within normal limits.",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Noticeable forward head or lateral tilt with slight cervical shift. Mind your sitting posture.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Noticeable forward head or lateral tilt with cervical shift. Posture management and muscle training recommended.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Significant forward head or lateral tilt with noticeable cervical shift. Professional assessment and systematic intervention recommended.",
  "xiong-zhui-pai-lie-ji-ben-zheng-chang-wu-ming-xian-jie-gou-yi-chang": "Thoracic alignment is generally normal, with no significant structural abnormalities.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Slight thoracic shift. Improve posture management.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Thoracic shift may affect torso stability. Targeted intervention training recommended.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Noticeable thoracic shift and decreased torso symmetry. Professional assessment and posture management recommended.",
  "yao-zhui-pai-lie-zheng-chang-zi-shi-ping-heng-wu-ming-xian-jie-gou-yi-chang": "Lumbar alignment is normal with balanced posture and no significant structural abnormalities.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Slight lumbar shift, but posture remains balanced. Core stability training recommended.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Lumbar shift may affect posture stability. Targeted adjustment training recommended.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Noticeable lumbar shift. Professional assessment and systematic improvement plan recommended.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "High levator scapulae, SCM, and upper trapezius involvement; low deep neck flexor involvement. Neck stability training and relaxation recommended.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "High left SCM and posterior scalene involvement; low right SCM involvement. Bilateral balance training and neck relaxation recommended.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "High right SCM involvement; low left SCM and posterior scalene involvement. Symmetric stability training and neck relaxation recommended.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "High left upper trapezius involvement; low middle/lower trapezius involvement. Middle/lower trapezius training and upper trapezius relaxation recommended.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "High hip internal rotator and adductor involvement; low gluteus medius involvement. Gluteus medius training and gentle stretching recommended.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "High gluteus medius and piriformis involvement; low hip adductor/internal rotator support and lateral knee stability. Lower-limb stability training and gluteal relaxation are recommended.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "High gluteus medius and piriformis involvement; low unilateral hip adductor, internal rotator, and LCL stability involvement. Bilateral balanced training recommended.",
  "jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Recommendation: Maintain balanced training and avoid unilateral overuse.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "High left hamstring and popliteus involvement; low quadriceps and soleus involvement. Quadriceps/soleus training and gentle stretching recommended.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "High left quadriceps involvement; low gluteus maximus and hamstring involvement. Glute-dominant/posterior-chain training and gentle stretching recommended.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "High right hamstring and popliteus involvement; low quadriceps and soleus involvement. Quadriceps/soleus training and gentle stretching recommended.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "High right quadriceps involvement; low gluteus maximus and hamstring involvement. Glute-dominant/posterior-chain training and gentle stretching recommended.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Slight spinal deviation. Mind daily posture and strengthen core muscles.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Moderate spinal deviation. Targeted training under professional guidance recommended.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-jiu-yi-jin-hang-duo-xue-ke-hui-zhen-ping-gu":"Severe spinal structural abnormality. A multidisciplinary medical consultation and assessment is recommended.",
  "ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Muscle assessment is normal. Please continue to maintain your healthy lifestyle.",
  "teng-tong-qian-zai-feng-xian-ping-gu": "Potential Pain Risk Assessment",
  "jing-bu": "Neck",
  "bei-bu": "Back",
  "yao-bu": "Lower Back",
  "jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Cervical Pain Potential Risk Score",
  "bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Dorsal Pain Potential Risk Score",
  "yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Lumbar Pain Potential Risk Score",
  "di-feng-xian": "Low Risk",
  "zhong-feng-xian": "Medium Risk",
  "ji-zhu-jie-gou-ke-shi-hua": "Spine Structure Visualization",
  "tuo-dong-xuan-zhuan-shi-tu": "Drag to Rotate",
  "ci-mo-xing-jin-gong-can-kao-shi-ji-ping-gu-yi-zhuan-ye-jian-ce-wei-zhun": "This model is for reference only. Please refer to a professional assessment for an actual diagnosis.",
  "bei-mian": "Back",
  "zheng-shi-tu": "Front View",
  "you-shi-tu": "Right View",
  "hou-shi-tu": "Posterior View",
  "zuo-shi-tu": "Left View",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "High right upper trapezius involvement; low middle/lower trapezius involvement. Middle/lower trapezius training and upper trapezius relaxation recommended.",
  "tun-xing": "Glute Shape",
  "dui-bi": "Comparison",
  "fang-xing-tun": "Square Shape",
  "li-xing-tun": "Pear Shape",
  "dao-san-jiao-xing-tun": "Inverted V-Shape",
  "yuan-xing-tun": "Round Shape",
  "jiao-li-xiang": "Good Shape",
  "mi-tao-tun": "Peach Shape",
  "ben-ci": "Current",
  "li-shi": "History",
  "ben-ci-li-shi": "Current, History",
  "tun-wei": "Hips",
  "tun-xing-shuo-ming": "About Glute Shapes",
  "tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai": "Glute shape refers to the curve and form of the area between the lower back and the thighs. This assessment can help individuals better manage their physical aesthetics and health.",
  "wo-zhi-dao-le": "I Understand",
  "fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du": "Square Shape: The square shape is characterized by similar width at the top and bottom, with straighter sides and less defined curves.",
  "yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing": "Round Shape: This shape is characterized by even fat distribution, creating a full and balanced appearance. It is considered an ideal glute shape.",
  "li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man": "Pear Shape: This shape is characterized by being narrower at the top and wider at the bottom, with more fat and muscle stored in the lower section.",
  "dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing": "Inverted V-Shape: This shape is characterized by being wider at the top and narrower towards the bottom, resembling an inverted triangle.",
  "mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing": "Peach Shape: This shape visually resembles a peach, featuring fullness at the bottom of the glutes that tapers to a narrower waist. It is considered an ideal shape.",
  "zan-wu-mo-xing": "No model available.",
  "ce-liang": "Measurement",
  "ben-ci-ce-liang": "Current Measurement",
  "ben-ci-ce-liang-wei-he-cheng-cheng-gong-ke-dao-she-bei-zai-ci-ce-liang": "Model generation failed for the current measurement. Please try scanning again at the device.",
  "gai-ri-qi-wu-mo-xing-qing-xuan-ze-qi-ta-dui-bi-ri-qi": "No model is available for this date. Please select another date for comparison.",
  "shou-ci-ce-liang-zan-wu-li-shi-shu-ju": "First measurement, no historical data available.",
  "mo-xing-jia-zai-shi-bai-qing-shua-xin-ye-mian-chang-shi-yi-xia": "Model failed to load. Please refresh the page and try again.",
  "jing-zhui-7": "C7 (7th Cervical Vertebra)",
  "di-gu-zhong-dian": "Midpoint of Sacrum",
  "di-gu-hou-shang-jiao": "Posterior Superior Angle of the Sacrum",
  "ren-ti-zhong-xin": "Center of Gravity",
  "spine-tips1":"This report is for reference only and should not be used as a basis for medical diagnosis. A comprehensive evaluation with a doctor's consultation is recommended.",
  "spine-tips2": "2025 Visbody Spinal Health Assessment System",
  'tun-xing-ping-gu': 'Glute Shape Assessment',
  "yi-xia-shi-nin-de-tun-xing-lei-xing":"Here is your glute shape type",
  "qi-ta-tun-xing": "Other Glute Shapes",
  "ji-zhu-ping-gu": "Spinal Assessment",
  "qing-shao-nian-ji-zhu-zhuan-xiang-feng-xian-ping-gu":"Adolescent Spinal Health Risk Assessment",
  "qing-shao-nian-ji-zhu-fa-yu-zhi-shu": "Adolescent Spinal Development Index",
  "xue-xi-zi-shi-fu-he-zhi-shu": "Study-Related Posture Load Index",
  "gu-ge-ping-heng-zhi-shu":"Skeletal Balance Index",
  "sheng-chang-qi-teng-tong-yu-jing-zhi-shu": "Growing Pains Warning Index",
  "ji-zhu-ce-wan-feng-xian-ping-fen": "Scoliosis Risk Score",
  "qia-yao-ji-shu-ji-ji":"Iliopsoas/Erector Spinae",
  "xia-bu-jin-zhang-fu-heng-ji-bao-ruo":"Lower Region Tension, Weak Transverse Abdominis",
  "ji-zhu-fa-yu-zheng-chang-wu-ming-xian-jie-gou-wen-ti":"Normal spinal development with no significant structural issues.",
  "cun-zai-qing-wei-fa-yu-yin-huan-jian-yi-gai-shan-zi-shi-xi-guan":"Minor developmental risks exist. Improving postural habits is recommended.",
  "zhong-du-fa-yu-feng-xian":"Moderate developmental risk.",
  "yan-zhong-ying-xiang-ji-zhu-fa-yu":"Severely affecting spinal development.",
  "xue-xi-zi-shi-liang-hao-ke-chang-shi-jian-wei-chi":"Good study posture, sustainable for long periods.",
  "zi-shi-you-dai-gai-shan-jian-yi-mei-45-fen-zhong-xiu-xi":"Posture needs improvement. Taking a break every 45 minutes is recommended.",
  "cun-zai-ming-xian-zi-shi-wen-ti-xu-yao-ding-qi-la-shen":"Significant postural issues exist. Regular stretching is needed.",
  "xue-xi-zi-shi-yan-zhong-bu-liang-huo-jiang-ying-xiang-xue-xi-xiao-shuai-he-fa-yu":"Severely poor study posture, which may affect learning efficiency and development.",
  "gu-ge-fa-yu-dui-cheng-zi-shi-wen-ding":"Symmetrical skeletal development, stable posture.",
  "cun-zai-qing-wei-bu-dui-cheng-jian-yi-jian-ce":"Minor asymmetry detected. Monitoring is recommended.",
  "fa-yu-bu-jun-yun-xu-yao-jiu-zheng-cuo-shi":"Uneven development, corrective measures are required.",
  "gu-ge-fa-yu-yan-zhong-bu-dui-cheng-ying-xiang-sheng-chang":"Severe skeletal asymmetry, affecting growth.",
  "zi-shi-liang-hao-teng-tong-feng-xian-di":"Good posture, low risk of pain.",
  "qing-du-teng-tong-feng-xian-jian-yi-zi-shi-guan-li":"Mild risk of pain. Posture management is recommended.",
  "zhong-du-teng-tong-feng-xian-xu-zhuan-ye-zhi-dao":"Moderate risk of pain, professional guidance is required.",
  "gao-du-teng-tong-feng-xian-ke-neng-yi-you-bu-shi-gan":"High risk of pain, discomfort may already be present.",
  "di-feng-xian-qing-bao-chi-liang-hao-zi-shi-xi-guan":"Low risk. Please maintain good postural habits.",
  "zhong-feng-xian-ke-neng-xu-yao-jin-yi-bu-guan-cha-huo-gan-yu":"Medium risk. Further observation or intervention may be needed.",
  "gao-feng-xian-xu-yao-ji-shi-jiu-yi-jin-hang-zhuan-ye-yi-liao-ping-gu-gan-yu":"High risk. Please seek timely medical evaluation and intervention.",
  "you-liang":"Excellent",
  "zhu-yi":"Caution",
  "gan-yu":"Intervention",
  "jing-shi":"Warning",
  "di-fu-he":"Low Load",
  "zhong-fu-he":"Medium Load",
  "gao-fu-he":"High Load",
  "guo-zai":"Overload",
  "ping-heng-xing":"Balanced",
  "qing-du-bu-ping-heng":"Mild Imbalance",
  "zhong-du-bu-ping-heng":"Moderate Imbalance",
  "yan-zhong-bu-ping-heng":"Severe Imbalance",
  "an-quan":"Safe",
  "wei-xian":"Risk",
  balanceReport: {
    'scoreUnit': 'Score',
    'compareLast': 'Compared to Last Time',
    'status': {
      'excellent': 'Excellent',
      'good': 'Good',
      'medium': 'Moderate',
      'fair': 'Average',
      'poor': 'Poor'
    },
    'levelDesc': [
      'Excellent',
      'Good',
      'Average',
      'Poor'
    ],
    'systemEvaluation': 'Sensory System Evaluation',
    'visualEvaluation': 'Visual Sensory Evaluation',
    'evaluationLevel': 'Rating',
    'unit': 'Unit: ',
    'swayRms': 'Sway Magnitude',
    'eyeCloseTest': 'Static Balance (Eyes Closed)',
    'copArea': 'COP Trajectory Area',
    'avgSpeed': 'Average Velocity',
    'maxDisplacement': 'Maximum Displacement',
    'centerTrajectory': 'COP Displacement Trajectory',
    'eyeOpenTest': 'Static Balance (Eyes Open)',
    'last': 'Last',
    'conclusion': {
      'eyeClose': {
        'level1': 'Excellent (Grade A) eyes-closed balance. High sensory integration allows stability without vision, enabling free movement in the dark.',
        'level2': 'Good (Grade B) eyes-closed balance. Effective somatosensory compensation allows adjustments without vision. Normal daily actions; brief adjustment needed if closing eyes suddenly.',
        'level3': 'Average (Grade C) eyes-closed balance. Suboptimal sensory function leads to larger sway. May feel unstable without visual aid and potentially need support.',
        'level4': 'Poor (Grade D) eyes-closed balance. Potential system impairments make balance difficult without visual aid. Significantly increased fall risk in the dark.'
      },
      'eyeOpen': {
        'level1': 'Excellent (Grade A) eyes-open balance. Highly efficient visual-somatosensory integration ensures stable posture with low energy use. Adapts well to complex environments.',
        'level2': 'Good (Grade B) eyes-open balance. Primarily relies on visual feedback for control, supplemented by somatosensory input. Stable during daily activities.',
        'level3': 'Average (Grade C) eyes-open balance. Relatively unstable posture; difficulty using visual input for balance. Prone to instability in visually distracting environments, requiring adjustments.',
        'level4': 'Poor (Grade D) eyes-open balance. Noticeable sway; poor ability to use visual input for balance. Potential sensory integration issues. Poor stability in daily activities increases fall risk.'
      }
    },
    'levelStatus': {
      'A': 'Grade A',
      'B': 'Grade B',
      'C': 'Grade C',
      'D': 'Grade D'
    },
    'chart': {
      'eyeCloseTest': 'Eyes-Closed Standing Test',
      'eyeOpenTest': 'Eyes-Open Standing Test',
      'yAxisLabels': [
        'Low',
        'Moderate',
        'High'
      ]
    },
    'selectionRport': 'Select a report to compare',
    'measureDes': 'Item Measurement Details',
    'balanceTittle': 'Balance Assessment',
    'pingDes': "Rating: Excellent, Good, Average, Poor",
  },
  "wu-yi-chang": "Normal",
  "neckReport": {
  "title": "Neck Function",
  "conclusion": "Neck Function Evaluation Conclusion",
  "loading": "Generating...",
  "failed": "Report Synthesis Failed",
  "analysis": "Analysis",
  "suggestion": "Suggestion",
  "suggestionText": "Seek professional screening and treatment for the specific cause"
}
}
